import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"];

  show(event) {
    const index = event.params.index;

    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("text-blue-600", "border-b-2", "border-blue-600");
        tab.classList.remove("text-gray-500", "hover:text-gray-700");
      } else {
        tab.classList.remove("text-blue-600", "border-b-2", "border-blue-600");
        tab.classList.add("text-gray-500", "hover:text-gray-700");
      }
    });

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index);
      panel.classList.toggle("block", i === index);
    });
  }
}
